import a from "i18next";
import { default as j } from "i18next";
import { initReactI18next as r } from "react-i18next";
const s = {
  close: "Lukk",
  open: "Åpne",
  save: "Lagre",
  cancel: "Avbryt",
  search: "Søk",
  clear: "Tøm",
  submit: "Send",
  edit: "Rediger",
  delete: "Slett",
  add: "Legg til",
  remove: "Fjern",
  back: "Tilbake",
  next: "Neste",
  previous: "Forrige",
  refresh: "Oppdater",
  download: "Last ned",
  upload: "Last opp",
  print: "Skriv ut",
  share: "Del",
  export: "Eksporter",
  import: "Importer"
}, i = {
  loading: "Laster...",
  error: "Feil",
  success: "Vellykket",
  warning: "Advarsel",
  info: "Informasjon",
  noData: "Ingen data tilgjengelig",
  notFound: "Ikke funnet",
  unauthorized: "Ikke autorisert"
}, l = {
  required: "Dette feltet er påkrevd",
  invalidEmail: "Ugyldig e-postadresse",
  invalidUrl: "Ugyldig URL",
  minLength: "Minimum {{min}} tegn",
  maxLength: "Maksimum {{max}} tegn",
  passwordMismatch: "Passordene matcher ikke"
}, g = {
  home: "Hjem",
  map: "Kart",
  search: "Søk",
  settings: "Innstillinger",
  help: "Hjelp",
  about: "Om",
  contact: "Kontakt",
  login: "Logg inn",
  logout: "Logg ut",
  profile: "Profil"
}, u = {
  zoomIn: "Zoom inn",
  zoomOut: "Zoom ut",
  fullscreen: "Fullskjerm",
  layers: "Lag",
  basemap: "Bakgrunnskart",
  location: "Min posisjon",
  measure: "Mål",
  print: "Skriv ut",
  drawing: "Tegning"
}, c = {
  signIn: "Logg inn",
  signOut: "Logg ut",
  signedIn: "Innlogget",
  signedOut: "Utlogget",
  signingIn: "Logger inn...",
  signingOut: "Logger ut...",
  error: "Feil ved innlogging",
  unauthorized: "Du har ikke tilgang til denne ressursen"
}, m = {
  title: "Innsyn Basis",
  description: "Grunnleggende kart og datavisning",
  showInfoLabel: "Vis informasjon",
  showInfoTooltip: "Klikk for å vise hjelpeinformasjon",
  themeToggleLabel: "Bytt tema",
  languageToggleLabel: "Bytt språk",
  arcgisOnlineLabel: "ArcGIS Online",
  signoutLabel: "Logg ut",
  userDropdownTooltip: "Brukerinnstillinger"
}, d = {
  yes: "Ja",
  no: "Nei",
  ok: "OK",
  and: "og",
  or: "eller",
  of: "av",
  in: "i",
  at: "på",
  to: "til",
  from: "fra",
  with: "med",
  without: "uten",
  all: "Alle",
  none: "Ingen",
  select: "Velg",
  selected: "Valgt",
  total: "Totalt",
  page: "Side",
  result: "Resultat",
  results: "Resultater"
}, p = {
  buttons: s,
  status: i,
  forms: l,
  navigation: g,
  map: u,
  auth: c,
  header: m,
  general: d
}, k = {
  lng: "nb",
  // Norwegian Bokmål as default
  fallbackLng: "nb",
  // have a common namespace used around the full app
  ns: ["common"],
  defaultNS: "common",
  interpolation: {
    escapeValue: !1
    // react already does escaping
  },
  resources: {
    nb: {
      common: p
    }
  }
};
a.use(r).init(k);
function h(e) {
  const n = a.createInstance(), t = Array.isArray(e.resources) ? f(...e.resources) : e.resources;
  return n.use(r).init({
    lng: e.defaultLanguage || "nb",
    fallbackLng: e.fallbackLanguage || "nb",
    debug: e.debug || !1,
    interpolation: {
      escapeValue: !1
      // React already escapes
    },
    resources: t
  }), n;
}
function f(...e) {
  return e.reduce((n, t) => (Object.keys(t).forEach((o) => {
    n[o] || (n[o] = {}), Object.assign(n[o], t[o]);
  }), n), {});
}
export {
  h as createI18n,
  k as defaultI18nConfig,
  j as i18n,
  f as mergeResources
};
//# sourceMappingURL=index.mjs.map
